import { images } from ".";

export const gardenTherapyData = {
    title: "gardenTherapy.title",
    subtitle: "gardenTherapy.subtitle",
    intro: {
        heading: "gardenTherapy.intro_heading",
        description: "gardenTherapy.intro_description"
    },
    benefits: [
        {
            id: 1,
            title: "gardenTherapy.benefits.0.title",
            text: "gardenTherapy.benefits.0.text",
            source: "(Kaplan & Kaplan, 1989)",
            icon: "fas fa-heart"
        },
        {
            id: 2,
            title: "gardenTherapy.benefits.1.title",
            text: "gardenTherapy.benefits.1.text",
            source: "(Sempik, Hine & Wilcox, 2010)",
            icon: "fas fa-walking"
        },
        {
            id: 3,
            title: "gardenTherapy.benefits.2.title",
            text: "gardenTherapy.benefits.2.text",
            source: "(Gonzalez et al., 2010)",
            icon: "fas fa-brain"
        },
        {
            id: 4,
            title: "gardenTherapy.benefits.3.title",
            text: "gardenTherapy.benefits.3.text",
            source: "",
            icon: "fas fa-users"
        }
    ],
    approach: [
        {
            id: 1,
            title: "gardenTherapy.approach.0.title",
            description: "gardenTherapy.approach.0.description",
            images: images.gardenTheraphy_2
        },
        {
            id: 2,
            title: "gardenTherapy.approach.1.title",
            description: "gardenTherapy.approach.1.description",
            images: images.gardenTheraphy_3
        },
        {
            id: 3,
            title: "gardenTherapy.approach.2.title",
            description: "gardenTherapy.approach.2.description",
            images: images.gardenTheraphy_4
        }
    ],
    bibliography: [
      "Kaplan, R., & Kaplan, S. (1989). The Experience of Nature: A Psychological Perspective. Cambridge University Press.",
      "Sempik, J., Hine, R., & Wilcox, D. (2010). Green Care: Concept, Evidence and Practice. Routledge.",
      "Gonzalez, M. T., Hartig, T., Patil, G. G., Martinsen, E. W., & Kirkevold, M. (2010). Therapeutic horticulture in clinical depression: a prospective study. Research on Aging, 32(4), 484–508.",
      "Clatworthy, J., Hinds, J., & Camic, P. M. (2013). Gardening as a mental health intervention: a review. Mental Health Review Journal, 18(4), 214–225."
    ],
    footerQuote: "gardenTherapy.footerQuote"
};

export default gardenTherapyData;